module.exports = __webpack_public_path__ + "static/media/shift72.a85780cf.png";